import { CustomerLaneGroupDetailData } from './customer-lane-group-detail-data';

export interface CustomerLaneMatchData {
  customer: CustomerRequiredData;
  customerLaneGroupDetail: CustomerLaneGroupDetailData;
}
export interface CustomerRequiredData {
  serviceTypeIds: number[];
}
